import { render, staticRenderFns } from "./UpgradesList.vue?vue&type=template&id=becf4852&scoped=true&"
import script from "./UpgradesList.vue?vue&type=script&lang=ts&"
export * from "./UpgradesList.vue?vue&type=script&lang=ts&"
import style0 from "./UpgradesList.vue?vue&type=style&index=0&id=becf4852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becf4852",
  null
  
)

export default component.exports